module.exports = "<a ng-show=\"isIFrame\" href=\"{{redirectURL}}\" id=\"closeButton\" target=\"_parent\" role=\"button\" ng-click=\"closeFrame($event)\">{{ content('base.closePayPalCheckoutLabel') }}</a>\n"


//////////////////
// WEBPACK FOOTER
// ../node_modules/noop-loader!../node_modules/xo-ui-components/src/escape-hatch/closeFrame/template.html
// module id = ../node_modules/noop-loader/index.js!../node_modules/xo-ui-components/src/escape-hatch/closeFrame/template.html
// module chunks = 0